type LogLevel = 'ERROR' | 'INFO' | 'DEBUG' | 'TRACE'

function send(level: LogLevel, event: string, extra?: Record<string, unknown>) {
  const entry: Record<string, unknown> = {
    timestamp: new Date().toISOString(),
    level,
    component: 'frontend',
    event,
    ...extra,
  }

  if (import.meta.env.DEV) {
    const prefix: Record<LogLevel, string> = {
      ERROR: '\x1b[31m[ERROR]\x1b[0m',
      INFO:  '\x1b[36m[INFO]\x1b[0m',
      DEBUG: '\x1b[90m[DEBUG]\x1b[0m',
      TRACE: '\x1b[90m[TRACE]\x1b[0m',
    }
    console.log(`${prefix[level]} ${event}`, extra ?? '')
  }

  fetch('/logs', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(entry),
    keepalive: true,
  }).catch(() => {})
}

export const log = {
  error: (event: string, extra?: Record<string, unknown>) => send('ERROR', event, extra),
  info:  (event: string, extra?: Record<string, unknown>) => send('INFO',  event, extra),
  debug: (event: string, extra?: Record<string, unknown>) => send('DEBUG', event, extra),
  trace: (event: string, extra?: Record<string, unknown>) => send('TRACE', event, extra),
}
